import { useTheme } from "@mui/material/styles";

export default function FooterRibbon({ height = 80 }) {
  const theme = useTheme();

  const primary = theme.palette.primary.main;

  return (
    <svg
      viewBox="0 0 1440 80"
      width="100%"
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      style={{
        "--accent": primary,
        "--accent-dark": primary,
        "--light": "#ffffff",
        "--dark": "#000000"
      }}
      role="img"
      aria-label="Decorative footer"
    >
      <g fill="var(--accent)">
        <polygon points="0,0 80,0 130,40 0,40" />
        <polygon points="1440,0 1360,0 1310,40 1440,40" />
        <polygon points="0,60 1440,60 1410,80 30,80" />
      </g>
      <path d="M20 20 H1420 L1396 40 H44 Z" fill="var(--accent-dark)" />
      <path d="M40 28 H1400 L1386 40 H54 Z" fill="var(--light)" />
      <path d="M34 44 H1406 L1392 52 H48 Z" fill="var(--accent-dark)" />
    </svg>
  );
}
